import React from 'react';
import Link from '@material-ui/core/Link';
import {makeStyles} from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Title from './Title';

function preventDefault(event) {
    event.preventDefault();
}

const useStyles = makeStyles({
    depositContext: {
        flex: 1,
    },
});

export default function Contact() {
    const classes = useStyles();
    return (
        <React.Fragment>
            <Title>Fire Extinguisher</Title>
            <Typography component="p" variant="h4">
                Resolved
            </Typography>
            <br/>
            <Typography color="textSecondary" className={classes.depositContext}>
                Message from Marița Mureșanu on 10 November, 2020
            </Typography>
            The janitor put the fire extinguishers up, this is resolved, thanks. <div>

            <br/>
            <br/>
            <Link color="primary" href="#" onClick={preventDefault}>
                Answer Close
            </Link>
        </div>
        </React.Fragment>
    );
}
